import { FC } from 'react';

import { Inbox } from '@mui/icons-material';
import { Card, Typography, Box, SxProps } from '@mui/material';

export interface CardProps {
  title: string;
  subtitle: string;
  sx?: SxProps;
}

export const NoResultsCard: FC<CardProps & SxProps> = ({ title, subtitle, children, sx }) => {
  return (
    <Card sx={{ px: 3, py: 5, width: '100%', ...sx }}>
      <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        <Inbox sx={{ width: 48, height: 48 }} />
        <Typography
          variant="h4"
          sx={{
            mt: 2,
          }}
        >
          {title}
        </Typography>
        <Typography color="text.secondary" variant="body1">
          {subtitle}
        </Typography>
        {children}
      </Box>
    </Card>
  );
};
